import SCARLET_BG from '@graphics/scenebg_xxtenshidarkxx.png'
import SCARLET_HEADER from '@graphics/Princessemo.webp'

export const SCARLET_THEME = {
  mainColor: '#f8008a',
  textColor: '#FFFFFF',
  backgroundImage: SCARLET_BG,
  contentBgColor: '#000000',
  headerImage: SCARLET_HEADER
}